<router-outlet><app-spinner></app-spinner></router-outlet>



// WEBPACK FOOTER //
// ./src/app/app.component.html